import { useParams } from "react-router-dom";
import JobApplicationForm from "../../containers/jobApplication/job-application-form";

export default function JobApplicationPage() {
  const { candidateId } = useParams();
  return <JobApplicationForm candidateId={candidateId || "new"} />;
}
